module.exports = ['$scope', 'railsResource',
($scope, $resource) ->
  Holding = $resource '/holdings/:id', { id: '@id' }

  @holdingsFilter = { listed: true };
  @holdings = Holding.query(@holdingsFilter)

  $scope.$watch 'search', (search) =>
    return unless search?
    if search.length > 0
      @holdings = Holding.query({ search: search })
    else
      @holdings = Holding.query(@holdingsFilter)

  @
]
